'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styling = require('@rexlabs/styling');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var animationDuration = 1.4;
var offset = 187;

var animRotate = (0, _styling.keyframes)('rotate', {
  '0%': { transform: 'rotate(0deg)' },
  '100%': { transform: 'rotate(360deg)' }
});

var animDash = (0, _styling.keyframes)('dash', {
  '0%': {
    strokeDashoffset: offset - 1 + 'px',
    transform: 'rotate(0deg)'
  },
  '50%': {
    strokeDashoffset: offset / 4 + 'px',
    transform: 'rotate(135deg)'
  },
  '100%': {
    strokeDashoffset: offset - 1 + 'px',
    transform: 'rotate(360deg)'
  }
});

var defaultStyles = (0, _styling.StyleSheet)({
  svg: {
    animation: animRotate + ' ' + animationDuration + 's linear infinite'
  },
  circle: {
    strokeDasharray: offset + 'px',
    transformOrigin: 'center'
  },
  spinner: {
    alignSelf: 'center',
    display: 'inline-flex'
  }
});

var LoadingSpinner = (_dec = (0, _styling.styled)(defaultStyles), _dec(_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(LoadingSpinner, _PureComponent);

  function LoadingSpinner(props) {
    (0, _classCallCheck3.default)(this, LoadingSpinner);

    // Create keyframes from given colors
    var _this = (0, _possibleConstructorReturn3.default)(this, (LoadingSpinner.__proto__ || (0, _getPrototypeOf2.default)(LoadingSpinner)).call(this, props));

    var colors = props.colors;

    var keyframeColors = colors.reduce(function (allColors, color, i) {
      return (0, _extends4.default)({}, allColors, (0, _defineProperty3.default)({}, 0 + i * 100 / colors.length + '%', {
        stroke: color
      }));
    }, {});
    keyframeColors['100%'] = { stroke: colors[0] };
    _this.keyframes = (0, _styling.keyframes)('colors', keyframeColors);
    return _this;
  }

  (0, _createClass3.default)(LoadingSpinner, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          s = _props.styles,
          size = _props.size,
          strokeWidth = _props.strokeWidth,
          colors = _props.colors,
          Tag = _props.Tag;

      strokeWidth = strokeWidth * (66 / size);
      return _react2.default.createElement(
        Tag,
        s('spinner'),
        _react2.default.createElement(
          'svg',
          (0, _extends4.default)({}, s('svg', { transform: 'rotate(0deg)' }), {
            width: size + 'px',
            height: size + 'px',
            viewBox: '0 0 66 66',
            xmlns: 'http://www.w3.org/2000/svg'
          }),
          _react2.default.createElement('circle', (0, _extends4.default)({}, s('circle', { transform: 'rotate(0deg)' }), {
            style: {
              animation: '\n                ' + animDash + ' ' + animationDuration + 's ease-in-out infinite,\n                ' + this.keyframes + ' ' + animationDuration * colors.length + 's ease-in-out infinite\n              '
            },
            fill: 'none',
            strokeWidth: strokeWidth,
            strokeLinecap: 'round',
            cx: 33,
            cy: 33,
            r: 33 - strokeWidth / 2
          }))
        )
      );
    }
  }]);
  return LoadingSpinner;
}(_react.PureComponent), _class2.defaultProps = {
  size: 35,
  strokeWidth: 6,
  colors: ['grey', 'dimgrey'],
  Tag: 'div'
}, _temp)) || _class);
exports.default = LoadingSpinner;